import React from "react";

type Props = {
    task       : any
    isSelected : boolean
    onClick    : callback
}

export default class SearchTaskOption extends React.Component<Props> {

    onClick = () => {
        if (this.props.onClick) this.props.onClick(this.props.task.id);
    }

    render() {
        const classes = Classes("row", "ui5-list-item", {
            'selected': this.props.isSelected,
        });

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="cell">
                    <div className="title">

                        {/*<div className="icon">*/}
                        {/*    <TaskTypeIcon className="" taskTypeId={this.props.task.taskTypeId} />*/}
                        {/*</div>*/}

                        {this.props.task.shortId && <span className="short-id m-r-10">#{this.props.task.shortId}</span>}

                        <div className="ui5-txt-default max-w-250">
                            {this.props.task.title}
                        </div>

                    </div>

                </div>
                <div className="cell align-r">
                    <div className="ui5-property max-w-200">{gd.session.projects.get(this.props.task.projectId)!.name}</div>
                </div>
            </div>
        )
    }
}
